module.exports = __webpack_public_path__ + "img/product1.1b8b64fe.png";